

export default function getUrl(ext) {
    return `https://api.dhacap.com/wp-json/wp/v2${ext}`
}
//http://localhost:8888/
